import { useMemo } from "react";
import { useSelector } from "react-redux";
import { themeSelector, type Theme } from "@/store/slices/themeSlice";

type CustomThemePalette = Omit<Theme, "tenancyLogo">;

const useCustomThemePalette = (): CustomThemePalette | undefined => {
  const { theme } = useSelector(themeSelector);

  const customPalette = useMemo(() => {
    if (theme) {
      const { tenancyLogo, ...palette } = theme;
      return palette;
    }
    return undefined;
  }, [theme]);

  return customPalette;
};

export { useCustomThemePalette };
